// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoButton_root__1gjUI","btn":"InfoButton_btn__2fmti"};